export default "__VITE_ASSET__e2effbee__"